// Rotating broadcast transition "stingers". A fresh one plays on every slide
// change (the parent keys it by the active slide id so it remounts & replays).
// Pass an explicit `variant` for smart routing (see stingerForSlide); otherwise
// `seq` rotates the style so the loop never feels repetitive.
const VARIANTS = ["wipe", "radar", "cloud"];

// Unified station transition: one signature branded wipe on every slide change
// for a cohesive on-air identity. The radar sweep stays reserved for severe /
// alert / tropical boards so those cuts feel appropriately urgent.
export function stingerForSlide(slide) {
  const s = `${slide?.id || ""} ${slide?.title || ""}`.toLowerCase();
  if (/(radar|futurecast|hrrr|alert|severe|tropical|storm|warning|watch|cyclone|impact|cone|outlook|lightning)/.test(s)) return "radar";
  return "wipe";
}

const CLOUDS = [
  { left: 8, top: 18, size: 760, delay: 0 },
  { left: 60, top: 10, size: 820, delay: 40 },
  { left: 34, top: 42, size: 900, delay: 20 },
  { left: 72, top: 50, size: 720, delay: 70 },
  { left: 2, top: 58, size: 700, delay: 90 },
  { left: 48, top: 66, size: 840, delay: 55 },
];

export default function SlideStinger({ seq = 0, variant, testId = "broadcast-stinger" }) {
  // Slide transitions disabled — clean hard cuts between slides (no stinger overlay).
  return null;
  // eslint-disable-next-line no-unreachable
  const n = VARIANTS.length;
  const chosen = variant || VARIANTS[(((seq % n) + n) % n)];

  if (chosen === "radar") {
    return (
      <div className="broadcast-stinger" data-testid={testId} data-variant="radar" aria-hidden>
        <div className="stinger-veil stinger-veil-radar">
          <div className="stinger-radar">
            <div className="stinger-radar-ring" />
            <div className="stinger-radar-ring r2" />
            <div className="stinger-radar-ring r3" />
            <div className="stinger-radar-sweep" />
            <span className="stinger-radar-mark">G<b>W</b>N</span>
          </div>
        </div>
      </div>
    );
  }

  if (chosen === "cloud") {
    return (
      <div className="broadcast-stinger" data-testid={testId} data-variant="cloud" aria-hidden>
        <div className="stinger-cloud-wrap">
          {CLOUDS.map((c, i) => (
            <span
              key={i}
              className="stinger-cloud"
              style={{ left: `${c.left}%`, top: `${c.top}%`, width: c.size, height: c.size, animationDelay: `${c.delay}ms` }}
            />
          ))}
          <span className="stinger-cloud-mark">G<b>W</b>N</span>
        </div>
      </div>
    );
  }

  // default: branded wipe panel
  return (
    <div className="broadcast-stinger" data-testid={testId} data-variant="wipe" aria-hidden>
      <div className="broadcast-stinger-panel">
        <span className="broadcast-stinger-mark">G<b>W</b>N</span>
      </div>
    </div>
  );
}
